export const IMAGES = {
  logo: require("@/assets/logo.jpg"),
  hero: "https://images.pexels.com/photos/17063686/pexels-photo-17063686.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=940",
  drill: "https://images.pexels.com/photos/6790048/pexels-photo-6790048.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  hammer: "https://images.pexels.com/photos/8092/pexels-photo.jpg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  swansea: "https://images.pexels.com/photos/12357876/pexels-photo-12357876.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=940",
  toolbelt: "https://images.unsplash.com/photo-1454694220579-9d6672b1ec2a?auto=format&fit=crop&w=940&q=80",
  drillWall: "https://images.unsplash.com/photo-1643509867448-57001e0c333d?crop=entropy&cs=srgb&fm=jpg&q=85&w=940",
  toolsFlat: "https://images.unsplash.com/photo-1639107992653-ab60d34c25fb?crop=entropy&cs=srgb&fm=jpg&q=85&w=940",
};
